import { render } from "./BasePrivacySwitcher.vue?vue&type=template&id=fbcb2b00"
import script from "./BasePrivacySwitcher.vue?vue&type=script&lang=js"
export * from "./BasePrivacySwitcher.vue?vue&type=script&lang=js"

import "./BasePrivacySwitcher.vue?vue&type=style&index=0&id=fbcb2b00&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__